/**
 * Fime – Our Core Offering Section (Industries template)
 *
 * Same interaction pattern as the Homepage's Customer Journey
 * section (desktop hover-follow panel, mobile Embla carousel), but
 * with its own unique element IDs (no collision risk even though the
 * two never render on the same page) and one addition: each card has
 * its own link, so the active panel's link (href/text/target) swaps
 * alongside the title/text on hover.
 */

import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';

// ── 1. Desktop: single sliding panel that follows the active circle ────────
const circleItems = document.querySelectorAll('#core-offering-circles .journey-circle-item');
const activePanel = document.getElementById('core-offering-active-panel');
const activeTitleEl = document.getElementById('core-offering-active-title');
const activeTextEl = document.getElementById('core-offering-active-text');
const activeLinkEl = document.getElementById('core-offering-active-link');
const activeLinkTextEl = document.getElementById('core-offering-active-link-text');

const NORMAL_WIDTH = 136;
const GAP = 24;

let activeIndex = 0;

function setActiveCircle(index) {
	circleItems.forEach(function (item) {
		item.classList.toggle('is-active', Number(item.dataset.index) === index);
	});
}

function positionPanel(index, animate) {
	if (!activePanel) return;
	const targetX = index * (NORMAL_WIDTH + GAP);

	activePanel.style.transition = animate
		? 'transform 0.6s cubic-bezier(0.16, 1, 0.3, 1)'
		: 'none';
	activePanel.style.transform = 'translateX(' + targetX + 'px)';
}

function updateContent(item) {
	if (!activeTitleEl || !activeTextEl) return;

	activeTitleEl.style.opacity = '0';
	activeTextEl.style.opacity = '0';
	if (activeLinkEl) activeLinkEl.style.opacity = '0';

	setTimeout(function () {
                const titleSrc = item.querySelector('.core-offering-title-src');
                const textSrc = item.querySelector('.core-offering-text-src');
                const linkTitleSrc = item.querySelector('.core-offering-link-title-src');

                activeTitleEl.textContent = titleSrc ? titleSrc.textContent : '';
                activeTextEl.textContent = textSrc ? textSrc.textContent : '';

                if (activeLinkEl) {
                        activeLinkEl.href = item.dataset.linkUrl || '#';
                        if (item.dataset.linkTarget) {
                                activeLinkEl.setAttribute('target', item.dataset.linkTarget);
                        } else {
                                activeLinkEl.removeAttribute('target');
                        }
                        activeLinkEl.style.opacity = '1';
                }
                if (activeLinkTextEl) {
                        activeLinkTextEl.textContent = linkTitleSrc ? linkTitleSrc.textContent : 'Learn more';
                }

                activeTitleEl.style.opacity = '1';
                activeTextEl.style.opacity = '1';
        }, 120);
}

circleItems.forEach(function (item) {
	item.addEventListener('mouseenter', function () {
		const index = Number(item.dataset.index);
		if (index === activeIndex) return;

		setActiveCircle(index);
		updateContent(item);
		positionPanel(index, true);
		activeIndex = index;
	});
});

positionPanel(activeIndex, false);

// ── 2. Mobile: Embla Carousel with autoplay + dot sync ─────────────────────
const emblaNode = document.getElementById('core-offering-embla');

if (emblaNode) {
	const viewportNode = emblaNode.querySelector('.embla__viewport');
	const dots = document.querySelectorAll('#core-offering-dots .journey-dot');

	const autoplay = Autoplay({ delay: 4000, stopOnInteraction: false });

	const emblaApi = EmblaCarousel(
		viewportNode,
		{ loop: true, align: 'start', containScroll: 'trimSnaps' },
		[autoplay]
	);

	function updateDots() {
		const selectedIndex = emblaApi.selectedScrollSnap();
		dots.forEach(function (dot, i) {
			dot.classList.toggle('is-active', i === selectedIndex);
		});
	}

	emblaApi.on('select', updateDots);
	updateDots();

	dots.forEach(function (dot) {
		dot.addEventListener('click', function () {
			emblaApi.scrollTo(Number(dot.dataset.slide));
		});
	});
}
